<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'周目标管理'}]" />-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="创客">
                                <el-input v-model="q.checkName" placeholder="请输入创客姓名/工号" :clearable="true"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="抢入链群">
                                <el-select filterable v-model="q.searchLianqun" clearable placeholder="请选择"
                                >
                                    <el-option
                                            v-for="(item,index) in lianqunList"
                                            :key="item.chainGroupCode"
                                            :label="item.chainGroupName"
                                            :value="item.chainGroupCode">
                                    </el-option>
                                </el-select>
                            </el-form-item> -->
<!--                            <el-form-item label="区域">
                                <el-select filterable v-model="q.searchQuyu" clearable placeholder="请选择">
                                    <el-option
                                            v-for="(item,index) in quyuList"
                                            :key="item.code"
                                            :label="item.name"
                                            :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>-->
                          <el-form-item label="区域" prop="searchQuyu">
                            <brselect clearable category="show_area" :v="q.searchQuyu"
                                      v-model="q.searchQuyu"></brselect>
                          </el-form-item>
                            <el-form-item label="是否周清">
                                <el-select filterable v-model="q.searchYq" clearable placeholder="请选择">
                                    <el-option value="1" label="已周清"></el-option>
                                    <el-option value="0" label="未周清"></el-option>
                                </el-select>
                            </el-form-item>
<!--                            <el-form-item label="目标类型">-->
<!--                                <el-select filterable v-model="q.targetType" clearable placeholder="请选择">-->
<!--                                    <el-option label="日常" value="0"></el-option>-->
<!--                                    <el-option label="城市网" value="1"></el-option>-->
<!--                                </el-select>-->
<!--                            </el-form-item>-->
                            <el-form-item label="部门">
                              <el-select filterable v-model="q.cdept" clearable placeholder="请选择"
                              >
                                <el-option
                                    v-for="(item,index) in deptList"
                                    :key="item.dept"
                                    :label="item.dept"
                                    :value="item.dept">
                                </el-option>
                              </el-select>
                            </el-form-item>
                        </div>
                        <el-collapse-transition>
                            <div v-show="isScreen">
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="年度">
                                        <el-select filterable v-model="q.year" clearable placeholder="请选择"
                                                   @change="getqWeeksBySelectYear">
                                            <el-option
                                                    v-for="(item,index) in yearList"
                                                    :key="item"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
<!--                                    <el-form-item  label="月" class="h-elformWrap-2" prop="username">
                                        <el-select filterable v-model="q.month" clearable placeholder="请选择"
                                        >
                                            <el-option
                                                    v-for="(item,index) in monthList"
                                                    :key="item"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>-->
                                    <el-form-item  label="周" class="h-elformWrap-2" prop="username">
                                        <el-select filterable v-model="q.week" clearable  placeholder="请选择"
                                        >
                                            <el-option
                                                    v-for="(item,index) in qweekList"
                                                    :key="item.week"
                                                    :label="item.weekStr"
                                                    :value="item.week">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                  <!-- <el-form-item label="链群类型">
                                    <el-select filterable v-model="q.lqType" clearable placeholder="请选择"
                                    >
                                      <el-option label="创单链群" value="0"></el-option>
                                      <el-option label="体验链群" value="1"></el-option>
                                    </el-select>
                                  </el-form-item> -->
                                </div>

                            </div>
                        </el-collapse-transition>

                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                        </div>
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">
                                新建目标
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <el-table
                        ref="multipleTable"
                        @selection-change="handleSelectionChange"
                        :data="tableData"
                        :border="true"
                        stripe
                        max-height="560"
                        style="width: 100%"
                        :span-method="objectSpanMethod"
                >
                    <!-- <el-table-column prop="daquName" label="大区" width="50" :show-overflow-tooltip="true"></el-table-column>-->
                    <el-table-column prop="userName" label="创客" width="70" ></el-table-column>
                    <el-table-column prop="quyuName" label="区域" width="70" ></el-table-column>
                    <el-table-column prop="deptName" label="部门" width="70" ></el-table-column>
                    <!-- <el-table-column prop="lianqunName" label="抢入链群" width="80" ></el-table-column> -->
<!--                    <el-table-column prop="targetTypeName" label="类型" width="70" ></el-table-column>-->
                    <el-table-column prop="year" label="年度" width="50" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="weekStr" label="周" width="125" :show-overflow-tooltip="true">
                        <template scope="scope">
                            {{scope.row.weekStr}}
                        </template>
                    </el-table-column>
                    <!--<el-table-column prop="cdate" label="提报时间"  width="90" :show-overflow-tooltip="true"></el-table-column>-->
                    <el-table-column prop="projectName" label="项目分类">
                      <template slot-scope="scope">
                        <el-tooltip placement="top">
                          <div slot="content"><pre align="left" style="max-width: 500px;">{{scope.row.projectName}}</pre></div>
                          <pre align="left" >{{scope.row.projectName}}</pre>
                        </el-tooltip>
                      </template>
                    </el-table-column>

                    <el-table-column prop="projectNameChild" label="子项目分类">
                      <template slot-scope="scope">
                        <el-tooltip placement="top">
                          <div slot="content"><pre align="left" style="max-width: 500px;">{{scope.row.projectNameChild}}</pre></div>
                          <pre align="left" >{{scope.row.projectNameChild}}</pre>
                        </el-tooltip>
                      </template>
                    </el-table-column>


                  <el-table-column prop="customerName" label="用户单位">
                    <template slot-scope="scope">
                      <el-tooltip placement="top">
                        <div slot="content"><pre align="left" style="max-width: 500px;">{{scope.row.customerName}}</pre></div>
                        <pre align="left" >{{scope.row.customerName}}</pre>
                      </el-tooltip>
                    </template>
                  </el-table-column>

                  <el-table-column prop="targetContent" label="目标内容">
                    <template slot-scope="scope">
                      <el-tooltip placement="top">
                        <div slot="content"><pre align="left" style="max-width: 700px;">{{scope.row.targetContent}}</pre></div>
                        <pre align="left" >{{scope.row.targetContent}}</pre>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                    <el-table-column prop="summarizeContent" label="总结" >
                        <template slot-scope="scope">
                            <el-tooltip placement="top">
                                <div slot="content"><pre align="left"  style="max-width: 500px;">{{scope.row.summarizeContent}}</pre></div>
                                <pre align="left" >{{scope.row.summarizeContent}}</pre>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                  <el-table-column prop="diffAnalysis" label="差异分析">
                    <template slot-scope="scope">

                      <el-tooltip placement="top">
                        <div slot="content"><pre align="left"  style="max-width: 500px;">{{scope.row.diffAnalysis}}</pre></div>
                        <pre align="left" >{{scope.row.diffAnalysis}}</pre>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                    <el-table-column prop="targetContent" label="解决措施">
                      <template slot-scope="scope">
                        <el-tooltip placement="top">
                          <div slot="content"><pre align="left" style="max-width: 700px;">{{scope.row.measure}}</pre></div>
                          <pre align="left" >{{scope.row.measure}}</pre>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  <el-table-column prop="responsibleUser" label="责任人">
                    <template slot-scope="scope">
                      <el-tooltip placement="top">
                        <div slot="content"><pre align="left" style="max-width: 700px;">{{scope.row.responsibleUser}}</pre></div>
                        <pre align="left" >{{scope.row.responsibleUser}}</pre>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="arrivalTime" label="到位时间">
                    <template slot-scope="scope">
                      <el-tooltip placement="top">
                        <div slot="content"><pre align="left" style="max-width: 700px;">{{scope.row.arrivalTime}}</pre></div>
                        <pre align="left" >{{scope.row.arrivalTime}}</pre>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="isClosedLoop" label="是否闭环">
                    <template slot-scope="scope">
                          <span v-if="scope.row.isClosedLoop == 0">
                            否
                          </span>
                      <span v-if="scope.row.isClosedLoop == 1">
                            是
                          </span>
                    </template>
                  </el-table-column>
                    <!--<el-table-column prop="lqHz" label="日评价汇总" width="100" :show-overflow-tooltip="true">-->
                    <!--    <template scope="scope">-->
                    <!--        {{scope.row.lqHz}}-->
                    <!--    </template>-->
                    <!--</el-table-column>-->
                    <el-table-column prop="comment" label="预实差评价" width="120">
                        <template slot-scope="scope">
                            <!--<el-input class="h-tableInput" v-model="scope.row.comment" :clearable="true"></el-input>-->
                            <el-input v-if="scope.row.id" type="textarea" v-model="scope.row.comment" placeholder="请输入" class="h-txtareaBox" rows = "2" ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sysScore" label="评价" width="80">
                        <template slot-scope="scope">
                            <brselect v-if="scope.row.id " class="h-tableInput" category="userCareLevel" :v="scope.row.sysScore" v-model="scope.row.sysScore"/>
                        </template>
                    </el-table-column>

<!--                  <el-table-column prop="isClose" label="差"width="60">-->
<!--                    <template slot-scope ="scope">-->
<!--                        <span v-if="scope.row.isClose == 1 ">-->
<!--                          是-->
<!--                        </span>-->
<!--                      <span v-if="scope.row.isClose == 0">否</span>-->
<!--                    </template>-->
<!--                  </el-table-column>-->

                    <el-table-column prop="complianceRate" label="达成率" width="80" :show-overflow-tooltip="true">
                        <template scope="scope">
                    <span v-if="scope.row.complianceRate">
                        {{scope.row.complianceRate *100}}%
                    </span>
                            <span v-else>

                    </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            fixed="right"
                            width="150"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.id " style="text-align: left;">
<!--                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="showDetail(scope.row.id)"
                                >总结</el-button>-->
                              <el-button
                                  type="text"
                                  size="small"
                                  class="h-tableLink h-btn"
                                  @click="showSummarizes(scope.row.id)"
                              >总结</el-button>
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        @click="updateDetail(scope.row.id)"
                                >编辑</el-button>
                                <el-button
                                        type="text"
                                        size="small"
                                        style="padding: 0;"
                                        class="h-tableLink h-btn"
                                        @click="del(scope.row.id)">
                                    删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                       @click="uploaddownexcelflagbtn">批量导入
                            </el-button>
                            <uploaddownexcel
                                    :visible.sync="uploaddownexcelflag"
                                    v-if="uploaddownexcelflag"
                                    clsname="userDailyTargetExcel"
                                    :startrow="2" @callback="uploadExcelFilecallback"/>
                            <el-button class="h-btn h-formBtn h-bgblueQ" v-auth="'zhoumubiaopingjia'" v-if="adminFlag" @click="saveGrade">调整评分</el-button>
                        </div>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query" />
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>新建目标</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
                <div style="padding: 12px;" class="dialogout X-dai">
                    <el-form :model="add" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine h-formbLine1">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceCon2">
                                    <div class="h-formLine">
                                        <el-form-item style="display:none" label="类型" class="h-elformWrap-4" prop="username">
                                            <el-select filterable v-model="add.type" disabled placeholder="请选择">
                                                <el-option
                                                        v-for="(item,index) in typeList"
                                                        :key="item.type"
                                                        :label="item.text"
                                                        :value="item.type">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="年度" class="h-elformWrap-4" prop="username">
                                            <el-select filterable v-model="add.year"  placeholder="请选择"
                                                       @change="getWeeksBySelectYear">
                                                <el-option
                                                        v-for="(item,index) in yearList"
                                                        :key="item"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="add.type == 1" label="月" class="h-elformWrap-4" prop="username">
                                            <el-select filterable v-model="add.month" placeholder="请选择"
                                            >
                                                <el-option
                                                        v-for="(item,index) in monthList"
                                                        :key="item"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="add.type == 2" label="周" class="h-elformWrap-4" prop="username">
                                            <el-select filterable v-model="add.week"  placeholder="请选择"
                                                       @change="getLianqunBySelectWeek"
                                            >
                                                <el-option
                                                        v-for="(item,index) in weekList"
                                                        :key="item.week"
                                                        :label="item.weekStr"
                                                        :value="item.week">
                                                </el-option>
                                            </el-select>
                                        </el-form-item >
                                    </div>
                                    <div class="h-formLine">
                                        <el-form-item label="本月预计还要下单" class="h-elformWrap-2 danwei" prop="monthPrice">
                                            <el-input v-model="add.monthPrice" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入内容"></el-input>
                                            <span>万元</span>
                                        </el-form-item>
                                        <el-form-item label="预计全月完成下单" class="h-elformWrap-2 danwei" prop="weekPrice">
                                          <el-input v-model="add.weekPrice" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入内容"></el-input>
                                          <span>万元</span>
                                        </el-form-item>
                                    </div>
                                    <!-- 新增项目信息 -->
                                    <div class="projectCon">
                                        <p><i>项目信息</i><el-button @click="addUser()" type="text" size="mini">新增</el-button> </p>
                                        <div v-for="(listIt, index) in ufrom" :key="index">
                                            <el-form-item  label="项目分类" >
                                                <el-select v-model="ufrom[index].projectName" @change="getProjectChild($event,index)">
                                                    <el-option
                                                            v-for="item in listProject"
                                                            :key="item.projectCode"
                                                            :label="item.projectName"
                                                            :value="item.projectName">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>


                                            <el-form-item  label="子项目" v-if="ufrom[index].isChild">
                                              <el-select v-model="ufrom[index].projectNameChild">
                                                <el-option
                                                    v-for="item in ufrom[index].listProjectChild"
                                                    :key="item.projectNameChild"
                                                    :label="item.projectNameChild"
                                                    :value="item.projectNameChild">
                                                </el-option>
                                              </el-select>
                                            </el-form-item>



                                            <el-form-item  label="用户单位" >
                                              <el-select v-model="ufrom[index].customerName" remote
                                                         filterable :filter-method="showFormList"  :v="ufrom[index].customerName"
                                                         clearable filterable placeholder="请输入"
                                                         :remote-method="showFormList">
                                                <el-option v-for="(item) in addrList"
                                                           :key="item.deptName"
                                                           :label="item.deptName"
                                                           :value="item.deptName">
                                                </el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item style="width:100%" label="目标内容" >
                                                <el-input style="border: #dedede 1px solid;
                                            width: 72%;" type="textarea" v-model="ufrom[index].targetContent"></el-input>
                                                <el-button style="margin-left:25px" @click="deleteUser(index)" v-if="index != 0" type="danger" size="mini">删除</el-button>
                                            </el-form-item>
                                        </div>


                                    </div>
                                    <div class="h-formLine" style="margin-right:60px">
                                        <el-form-item label="链群" class="h-elformWrap-2" v-if="this.addlianqunList.length >0">
                                            <el-select filterable v-model="add.lianqun" clearable placeholder="请选择"
                                                       @change="$forceUpdate()"
                                            >
                                                <el-option
                                                        v-for="(item,index) in addlianqunList"
                                                        :key="item.chainGroupCode"
                                                        :label="item.chainGroupName"
                                                        :value="item.chainGroupCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>

                                        <!-- <el-form-item label="目标内容" class="h-elformWrap-1">
                                            <el-input type="textarea" v-model="add.targetContent" placeholder="请输入" class="h-txtareaBox" rows="5"></el-input>
                                        </el-form-item> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                    <!--                    <el-button class="h-btn h-bBtn h-bggreen" @click="saveCreate" v-show="isShowSaveCredit">暂存-->
                    <!--                    </el-button>-->
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="adduser">新增客户</el-button>
                </div>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="showDialog" v-loading="showloading" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>总结</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
                <div style="padding: 12px;" class="dialogout X-dai">
                    <el-form :model="add" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine h-formbLine1">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceCon2">
                                    <div class="h-formLine">
                                        <el-form-item style="display:none" label="类型" class="h-elformWrap-4" prop="username">
                                            <el-select filterable v-model="add.type" disabled placeholder="请选择">
                                                <el-option
                                                        v-for="(item,index) in typeList"
                                                        :key="item.type"
                                                        :label="item.text"
                                                        :value="item.type">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="年度" class="h-elformWrap-4" prop="username">
                                            <el-select filterable v-model="add.year" disabled  placeholder="请选择"
                                                       @change="getWeeksBySelectYear">
                                                <el-option
                                                        v-for="(item,index) in yearList"
                                                        :key="item"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="add.type == 1" label="月" class="h-elformWrap-4" prop="username">
                                            <el-select filterable v-model="add.month" disabled placeholder="请选择"
                                            >
                                                <el-option
                                                        v-for="(item,index) in monthList"
                                                        :key="item"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="add.type == 2" label="周" class="h-elformWrap-4" prop="username">
                                            <el-select filterable v-model="add.week" disabled  placeholder="请选择"
                                            >
                                                <el-option
                                                        v-for="(item,index) in weekList"
                                                        :key="item.week"
                                                        :label="item.weekStr"
                                                        :value="item.week">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="h-formLine" style="margin-right:60px">
                                        <el-form-item label="结果总结" class="h-elformWrap-1">
                                            <el-input type="textarea" v-model="add.summaryContent" placeholder="请输入" class="h-txtareaBox" rows="5"></el-input>
                                        </el-form-item>

                                        <el-form-item label="差异分析" class="h-elformWrap-1">
                                            <el-input type="textarea" v-model="add.diffAnalysis" placeholder="请输入" class="h-txtareaBox" rows="5"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="updateDialog" v-loading="updateloading" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>修改目标</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
                <div style="padding: 12px;" class="dialogout X-dai">
                    <el-form :model="add" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine h-formbLine1">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceCon2">
                                    <div class="h-formLine">
                                        <el-form-item style="display:none" label="类型" class="h-elformWrap-4" prop="username">
                                            <el-select filterable v-model="add.type" disabled placeholder="请选择">
                                                <el-option
                                                        v-for="(item,index) in typeList"
                                                        :key="item.type"
                                                        :label="item.text"
                                                        :value="item.type">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="年度" class="h-elformWrap-4" prop="username">
                                            <el-select filterable v-model="add.year"  placeholder="请选择"
                                                       @change="getWeeksBySelectYear">
                                                <el-option
                                                        v-for="(item,index) in yearList"
                                                        :key="item"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="add.type == 1" label="月" class="h-elformWrap-4" prop="username">
                                            <el-select filterable v-model="add.month" placeholder="请选择"
                                            >
                                                <el-option
                                                        v-for="(item,index) in monthList"
                                                        :key="item"
                                                        :label="item"
                                                        :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="add.type == 2" label="周" class="h-elformWrap-4" prop="username">
                                            <el-select filterable v-model="add.week"  placeholder="请选择"
                                                       @change="getLianqunBySelectWeek"
                                            >
                                                <el-option
                                                        v-for="(item,index) in weekList"
                                                        :key="item.week"
                                                        :label="item.weekStr"
                                                        :value="item.week">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="h-formLine" >

                                        <el-form-item label="链群" class="h-elformWrap-2" v-if="this.addlianqunList.length >0">
                                            <el-select filterable v-model="add.lianqun" clearable placeholder="请选择"
                                                       @change="$forceUpdate()"
                                            >
                                                <el-option
                                                        v-for="(item,index) in addlianqunList"
                                                        :key="item.chainGroupCode"
                                                        :label="item.chainGroupName"
                                                        :value="item.chainGroupCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="本月预计还要下单" class="h-elformWrap-2 danwei" prop="monthPrice">
                                            <el-input v-model="add.monthPrice" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入内容"></el-input>
                                            <span>万元</span>
                                        </el-form-item>
                                      <el-form-item label="预计全月完成下单" class="h-elformWrap-2 danwei" prop="weekPrice">
                                        <el-input v-model="add.weekPrice" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入内容"></el-input>
                                        <span>万元</span>
                                      </el-form-item>
                                    </div>
                                    <!--  -->
                                    <!-- 新增项目信息 -->
                                    <div class="projectCon">
                                        <p><i>项目信息</i><el-button @click="addUser()" type="text" size="mini">新增</el-button> </p>
                                        <div v-for="(listIt, index) in ufrom" :key="index">
                                            <el-form-item  label="项目分类" >
                                                <el-select v-model="ufrom[index].projectName" @change="getProjectChild($event,index)">
                                                    <el-option
                                                            v-for="item in listProject"
                                                            :key="item.projectName"
                                                            :label="item.projectName"
                                                            :value="item.projectName">
                                                        {{item.projectName}}
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>

                                            <el-form-item  label="子项目" v-if="ufrom[index].isChild">
                                              <el-select v-model="ufrom[index].projectNameChild">
                                                <el-option
                                                    v-for="item in ufrom[index].listProjectChild"
                                                    :key="item.projectNameChild"
                                                    :label="item.projectNameChild"
                                                    :value="item.projectNameChild">
                                                </el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item  label="用户单位" >
                                              <el-select v-model="ufrom[index].customerName" remote
                                                         filterable :filter-method="showFormList"  :v="ufrom[index].customerName"
                                                         clearable filterable placeholder="请输入"
                                                         :remote-method="showFormList">
                                                <el-option v-for="(item) in addrList"
                                                           :key="item.deptName"
                                                           :label="item.deptName"
                                                           :value="item.deptName">
                                                </el-option>
                                              </el-select>
                                            </el-form-item>
                                            <el-form-item style="width:100%" label="目标内容" >
                                                <el-input style="border: #dedede 1px solid;
                                            width: 72%;" type="textarea" v-model="ufrom[index].targetContent"></el-input>
                                                <el-button style="margin-left:25px" @click="deleteUser(index)" v-if="index != 0" type="danger" size="mini"  :disabled="getDeleteStatus(ufrom[index].status)">删除</el-button>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 yonghu" @close="cancel('f')">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>新增客户</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLine h-mrb-38">
                <el-form :model="f" :rules="rules" ref="f"
                         :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                    <el-form-item label="用户类型" class="h-elformWrap-2" prop="userName">
                        <el-select v-model="f.userType" :clearable="true"
                                   placeholder="请选择">
                            <el-option label="潜在经销商" value="1"></el-option>
                            <el-option label="潜在客户" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户名称" class="h-elformWrap-2" prop="userName">
                        <el-input v-model.trim="f.userName" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="区域" class="h-elformWrap-2" prop="areaCode">
                        <brselect category="YLRegion" :v="f.areaCode" v-model="f.areaCode" :clearable="true"
                        />
                    </el-form-item>
                    <el-form-item label="渠道" class="h-elformWrap-2" prop="channelCode">
                        <brselect category="loud_region" :v="f.channelCode" v-model="f.channelCode"
                                  :clearable="true"
                        />
                    </el-form-item>
                    <el-form-item label="部门/科室" class="h-elformWrap-2" :rules="[
								  { required: true, message: '部门/科室不能为空', trigger: 'change'},
								]" prop="department">
                        <el-input v-model.trim="f.department" placeholder="请输入"/>
                    </el-form-item>
                    <el-form-item label="联系人" class="h-elformWrap-2" :rules="[
								  { required: true, message: '联系人不能为空', trigger: 'change'},
								]" prop="contactuserName">
                        <el-input v-model.trim="f.contactuserName" placeholder="请输入"/>
                    </el-form-item>
                    <el-form-item label="联系方式" class="h-elformWrap-2" :rules="[
								  { required: true, message: '联系方式不能为空', trigger: 'change'},
								]" prop="telephone">
                        <el-input v-model.trim="f.telephone" placeholder="请输入" maxlength="20"
                                  oninput="value=value.replace(/[^\d]/g,'')"/>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel('f')">取消</el-button>
                <el-button class="h-btn h-formBtn h-bgblueQ2" @click="insert">提交
                </el-button>
            </div>
        </el-dialog>


      <el-dialog :close-on-click-modal="false" :visible.sync="showSummarize" v-loading="showSummarizeing" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>总结</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;" class="dialogout X-dai">
            <el-form :model="add" label-position="right" :inline="true"
                     class="demo-ruleForm h-formbLine h-formbLine1">
              <div class="h-rowCon">
                <div class="h-pieceIn2">
                  <div class="h-pieceCon2">
                    <div class="h-formLine">
                      <el-form-item style="display:none" label="类型" class="h-elformWrap-4" prop="username">
                        <el-select filterable v-model="add.type" disabled placeholder="请选择">
                          <el-option
                              v-for="(item,index) in typeList"
                              :key="item.type"
                              :label="item.text"
                              :value="item.type">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="年度" class="h-elformWrap-4" prop="username">
                        <el-select filterable v-model="add.year"  placeholder="请选择"
                                   @change="getWeeksBySelectYear" disabled>
                          <el-option
                              v-for="(item,index) in yearList"
                              :key="item"
                              :label="item"
                              :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item v-if="add.type == 1" label="月" class="h-elformWrap-4" prop="username">
                        <el-select filterable v-model="add.month" placeholder="请选择" disabled
                        >
                          <el-option
                              v-for="(item,index) in monthList"
                              :key="item"
                              :label="item"
                              :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item v-if="add.type == 2" label="周" class="h-elformWrap-4" prop="username">
                        <el-select filterable v-model="add.week"  placeholder="请选择" disabled
                                   @change="getLianqunBySelectWeek"
                        >
                          <el-option
                              v-for="(item,index) in weekList"
                              :key="item.week"
                              :label="item.weekStr"
                              :value="item.week">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="h-formLine" >

                      <el-form-item label="链群" class="h-elformWrap-2" v-if="this.addlianqunList.length >0">
                        <el-select filterable v-model="add.lianqun" clearable placeholder="请选择" disabled
                                   @change="$forceUpdate()"
                        >
                          <el-option
                              v-for="(item,index) in addlianqunList"
                              :key="item.chainGroupCode"
                              :label="item.chainGroupName"
                              :value="item.chainGroupCode">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="本月预计还要下单" class="h-elformWrap-2 danwei" prop="monthPrice">
                        <el-input v-model="add.monthPrice" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入内容" disabled></el-input>
                        <span>万元</span>
                      </el-form-item>
                      <el-form-item label="预计全月完成下单" class="h-elformWrap-2 danwei" prop="weekPrice">
                        <el-input v-model="add.weekPrice" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入内容" disabled></el-input>
                        <span>万元</span>
                      </el-form-item>

                      <el-form-item label="差异分析" class="h-elformWrap-1 " style="margin-left: -35px">
                        <el-input type="textarea" v-model="add.diffAnalysis" placeholder="请输入" class="h-txtareaBox" rows="5"></el-input>
                      </el-form-item>
                      <el-form-item style="margin-left: -35px" class="h-elformWrap-1 " label="解决措施" >
                        <el-input class="h-txtareaBox" type="textarea" v-model="add.measure"></el-input>
                      </el-form-item>
                      <el-form-item label="责任人"  prop="responsibleUser">
                        <el-input v-model="add.responsibleUser"  placeholder="请输入内容"></el-input>
                      </el-form-item>
                      <el-form-item label="到位时间" >
                        <el-date-picker type="date" placeholder="选择时间" value-format="yyyy-MM-dd" v-model="add.arrivalTime"
                        ></el-date-picker>
                      </el-form-item>
                    </div>
                    <!--  -->
                    <!-- 新增项目信息 -->
                    <div class="projectCon">
                      <p><i>项目信息</i><el-button @click="addUser()" type="text" size="mini">新增</el-button> </p>
                      <div v-for="(listIt, index) in ufrom" :key="index">
                        <el-form-item  label="项目分类" >
                          <el-select v-model="ufrom[index].projectName" disabled>
                            <el-option
                                v-for="item in listProject"
                                :key="item.projectName"
                                :label="item.projectName"
                                :value="item.projectName">
                              {{item.projectName}}
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item  label="子项目" >
                          <el-select v-model="ufrom[index].projectNameChild" disabled>
                            <el-option
                                v-for="item in ufrom[index].listProjectChild"
                                :key="item.projectNameChild"
                                :label="item.projectNameChild"
                                :value="item.projectNameChild">
                              {{item.projectName}}
                            </el-option>
                          </el-select>
                        </el-form-item>


                        <el-form-item  label="用户单位" >
                          <el-select v-model="ufrom[index].customerName" remote disabled
                                     filterable :filter-method="showFormList"  :v="ufrom[index].customerName"
                                     clearable filterable placeholder="请输入"
                                     :remote-method="showFormList">
                            <el-option v-for="(item) in addrList"
                                       :key="item.deptName"
                                       :label="item.deptName"
                                       :value="item.deptName">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item style="width:100%" label="目标内容" >
                          <el-input style="border: #dedede 1px solid;
                                            width: 72%;"  v-model="ufrom[index].targetContent" disabled></el-input>
                        </el-form-item>
                        <el-form-item style="width:100%" label="目标总结" >
                          <el-input style="border: #dedede 1px solid;
                                            width: 72%;" type="textarea" v-model="ufrom[index].summarizeContent"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitSummarize()">提交</el-button>
          </div>
        </div>
      </el-dialog>

    </div>
</template>

<script>
    import ss from "../../../api/SystemService";
    import updownfile from '../../../utils/updownfile'
    import util from "../../../utils/util";
    import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import moment from 'moment'
    import axios from "axios";
    import store from "../../../store";
    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                // 展开折叠筛选
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //表单
                q: {
                    year:new Date().getFullYear(),
                    checkName:'',
                    cdsDate:null,
                    lqType: 1,
                    type : 2,
                    pageSize: 10,
                    week:'',
                    pageNo: 1,
                    total:0,
                    cdept:'',
                },
                //表单
                f: {
                    areaCode: null,
                    channelCode: null,
                    userName: null,
                    department: null,
                    contactuserName: null,
                    telephone: null,
                    userType: null,
                },
                add:{
                    year :new Date().getFullYear(),
                    type : 2,
                    month :new Date().getMonth()+2,
                    weekPrice:'',
                    monthPrice:'',
                    diffAnalysis:'',
                    summarizeContent:'',
                    responsibleUser:'',
                    arrivalTime:'',
                    summaryContent:'',
                },
                summarize:'',
                isfb:1,
                showhistory:false,
                adminFlag:false,
                projectFlag:false,
                addrList: [],
                instid:null,
                pingfen:'暂无',
                paiming:'暂无',
                //表格
                multipleSelection: [],
                multipleSelectionDialog:[],
                tableData: [],
                //新增客户弹窗
                dialogFormVisible: false,
                //发布排行
                dialogFlag:false,
                uploaddownexcelflag:false,

                sumRank:[],
                quyuList:[],
                yearList:[new Date().getFullYear()-1,new Date().getFullYear(),new Date() .getFullYear()+1],
                qyearList:[],
                typeList:[{type:1,text:'月目标'},{type:2,text:'周目标'}],
                monthList:[1,2,3,4,5,6,7,8,9,10,11,12],
                weekList :[],
                lianqunList : [],
                deptList: [],
                addlianqunList : [],
                qweekList :[],
                newDialog: false,
                showDialog:false,
                updateDialog:false,
                showloading:false,
                updateloading:false,
                showSummarize:false,
                showSummarizeing:false,
                nosum:'',
                nosoc:'',
                rules: {

                },
                q2: {
                    pageSize: 10,
                    pageNo: 1,
                    total:0,
                    rqstatus:'',
                },
                ufrom:[
                    {projectName:'',
                      projectNameChild:'',
                      customerName:"",
                      targetContent:"",
                      remnant:0,
                      summarizeContent:"",
                      dayPlanContent:"",
                      isChild:false,
                      responsibleUser:"",
                      listProjectChild:[],
                    }
                ],
                listProject:[],
                listProjectChild:[],
                groupList: [],
                groupArr:[],
                /// value: ''
                position: 0,
                isChild:false,
                rowSpanArr: [],
            };
        },
        created() {
              if(this.$store.getters.hasRole('swyl_admin')||this.$store.getters.hasRole('FANGAN')||this.$store.getters.hasRole('YIMIAO_PINGTAI')){
                this.adminFlag = true;
              }
              this.getAllLianqun();
              this.getQuyu();
              this.getqWeeks(new Date().getFullYear(),1);
              this.getWeeks(new Date().getFullYear());
              this.getDept();
              for(var i =2021;i<new Date() .getFullYear()+2;i++){
                this.qyearList.push(i);
              }
              //新增
              this.getProject()
              this.getuserList()
              this.q.week = this.getWeekNum()
        },

        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },

        watch:{
            'this.ufrom.customerName': {
                deep: true,
                handler: function (newVal,oldVal){
                    this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
                    var len = this.groupList.length;//groupList
                    var arr = [];
                    for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
                        if (this.groupList[i].name.indexOf(this.ufrom.customerName) >= 0) {
                            arr.push({
                                value:this.groupList[i].userName,
                                id:this.groupList[i].userCode
                            })
                        }
                    }
                    this.groupArr = arr
                }
            },
        },
        methods: {
            getProject(){
                ss.MuBiao.getProject().then(res => {
                    console.log(res.msg)
                    this.listProject = res.msg
                })
            },
            //获取用户单位
            showFormList(value) {
              // console.log("value188776676","111111111111111111111111")
              var data = value;
              console.log("value188776676", data)
              ss.OrderMainService.getCompanyInfo(value).then(rd => {
                this.addrList = rd;
              })
            },

            groupListMe(e,index) {
                console.log(e)
                console.log(index)
                var data  = this.ufrom[index].customerName
                ss.MuBiao.getUser(data).then(res => {
                    console.log(res)
                    this.groupList = []
                    this.groupArr = []
                    this.groupList = res.msg
                    for(let item of this.groupList) {
                        this.groupArr.push({
                            value:item.userName,
                            id:item.userCode
                        })
                    }
                })
            },
            getKnowWeek() {
              var week1 = this.getWeekNum();
              this.qweekList.forEach(element => {
                if(week1 == element.week){
                  this.q.week = element.week
                }
              });
            },
            querySearchGroup(queryString, cb) {
                var groupArr = this.groupArr;
                cb(groupArr);
            },
            selectGroup(val) {
                console.log(val)
                this.ufrom.customerName= val.value
            },

            //关闭弹框的事件
            closeDialog(){
                this.newDialog = false
                this.updateDialog = false
                this.xxx = '';//清空数据
                console.log("beiinsfdsjafja ")
                this.add.weekPrice='';
                this.add.monthPrice='';
                this.ufrom=[
                    {projectName:'',customerName:"",targetContent:"",remnant:0,summarizeContent:"", listProjectChild:[],}
                ]
            },
          //关闭弹框的事件
            closeDialogSummarize(){
              this.showSummarize = false
              this.showSummarizeing = false
              this.xxx = '';//清空数据
              console.log("beiinsfdsjafja ")
              this.add.weekPrice='';
              this.add.monthPrice='';
              this.ufrom=[
                {projectName:'',projectNameChild:'',customerName:"",targetContent:"",remnant:0,summarizeContent:""}
              ]
            },


            getuserList(){
                // var data  = this.
                // ss.MuBiao.getUser(data).then(res => {
                //     console.log(res)
                //   //  this.listProject = res.msg
                // })

            },
            addUser(){
                this.ufrom.push({projectName:"",projectNameChild:'',customerName:"",targetContent:"",listProjectChild:[]})
            },
            deleteUser(index){
                console.log(index)
                this.ufrom.splice(index, 1)
            },
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            readd(){
                this.add={
                    year :new Date().getFullYear(),
                    type : 2,
                    month :new Date().getMonth()+2
                }
            },
            //调整评分
            saveGrade(){
                ss.MuBiao.tzGrade({"list":this.tableData}).then(rd => {
                    this.$msg.msgs("调整保存成功");
                    this.query();
                })
            },
            getQuyu(){
                ss.RiqPingj.selectAllQuyu().then(rd => {
                    this.quyuList = rd;
                })
            },
            genzongLiuch(r){
                this.instid = r.instid;
                this.showhistory = true;
            },
            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //弹框表格
            handleSelectionChangeDialog(val){
                this.multipleSelectionDialog = val;
            },
            getLianqun(q){
                ss.createMonthGoal.getLianqun(q).then(rd => {
                    this.lianqunList = rd;
                })
            },
            getDept(q){
              ss.MuBiao.getDeptList(q).then(rd => {
                this.deptList = rd;
              })
            },
            getWeeks(y){
                ss.MuBiao.getWeekList({year:y}).then(rd => {
                    this.weekList = rd;
                })
            },
            getqWeeks(y,z){
                ss.MuBiao.getWeekList({year:y,stype:z}).then(rd => {
                    this.qweekList = rd;
                    this.getKnowWeek();
                })
            },
            //获取今年是第几周
            getWeekNum() {
              //获得当前日期是第几周的方法
              var year = new Date().getFullYear();
              var week = moment(new Date()).format("E");//获得今天是星期几
              console.log("week",week)
              var startweek = moment(new Date(year + "-01-01")).format("E");//获得今年的1月1号是星期几
              //今天到1月1号的时间戳之差
              var millisDiff =
                  new Date(moment().format("yyyy-MM-DD")).getTime() -
                  new Date(year + "-01-01").getTime();
              var days =
                  (millisDiff -
                      week * (24 * 60 * 60 * 1000) -
                      (7 - startweek) * (24 * 60 * 60 * 1000)) /
                  86400000;
              return days / 7 + 1;
              //这里加的2代表的是本周和今年1月1号所在的那一周
            },


          getWeeksBySelectYear(){
                this.getWeeks(this.add.year);
                ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
                    this.addlianqunList = rd;
                })
            },
            getLianqunBySelectWeek(){
                // ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
                //     this.addlianqunList = rd;
                // })
                // this.add.lianqun ="";
            },
            getqWeeksBySelectYear(){
                this.getqWeeks(this.q.year,1);
            },
            commitCreate() {
                if(!this.add.type){
                    this.$message({
                        type: "error",
                        message: '类型不能为空'
                    });
                    return false;
                }
                if(!this.add.year){
                    this.$message({
                        type: "error",
                        message: '年度不能为空'
                    });
                    return false;
                }
                if(this.add.type == 1 &&!this.add.month){
                    this.$message({
                        type: "error",
                        message: '月度不能为空'
                    });
                    return false;
                }
                if(this.add.type == 2 &&!this.add.week){
                    this.$message({
                        type: "error",
                        message: '周不能为空'
                    });
                    return false;
                }
                // if(!this.add.summaryContent &&  this.add.type !== 2){
                //     this.$message({
                //         type: "error",
                //         message: '结果总结不能为空'
                //     });
                //     return false;
                // }

                if(this.add.type == 1)
                    this.add.week = null
                if(this.add.type == 2){
                    this.add.month = null
                    this.add.detailList=this.ufrom
                    if(this.summarize == '1'){
                        var data ={
                            diffAnalysis: this.add.diffAnalysis,
                            responsibleUser: this.add.responsibleUser,
                            arrivalTime: this.add.arrivalTime,
                            summarizeContent: this.add.summarizeContent,
                            summaryContent: this.add.summaryContent,
                            id:this.add.id,
                            detailList:[]
                        }
                        this.add = data
                    }
                }



                ss.MuBiao.saveOrUpdate(this.add).then(response => {
                    if (response.f) {
                        this.$message({
                            type: "success",
                            message: response.msg
                        });
                        //this.readd();
                        this.query();
                        //this.newDialog = false;
                        this.showDialog = false;
                        //this.updateDialog = false;
                        this.closeDialog()
                    } else {
                        this.$message({
                            type: "error",
                            message: response.msg
                        });
                    }

                })
            },
          commitSummarize() {
            if(!this.add.type){
              this.$message({
                type: "error",
                message: '类型不能为空'
              });
              return false;
            }
            if(!this.add.year){
              this.$message({
                type: "error",
                message: '年度不能为空'
              });
              return false;
            }
            if(this.add.type == 1 &&!this.add.month){
              this.$message({
                type: "error",
                message: '月度不能为空'
              });
              return false;
            }
            if(this.add.type == 2 &&!this.add.week){
              this.$message({
                type: "error",
                message: '周不能为空'
              });
              return false;
            }
            // if(!this.add.summaryContent &&  this.add.type !== 2){
            //     this.$message({
            //         type: "error",
            //         message: '结果总结不能为空'
            //     });
            //     return false;
            // }

            if(this.add.type == 1)
              this.add.week = null
            if(this.add.type == 2){
              this.add.month = null
              this.add.detailList=this.ufrom
              if(this.summarize == '1'){
                var data ={
                  diffAnalysis: this.add.diffAnalysis,
                  responsibleUser: this.add.responsibleUser,
                  arrivalTime: this.add.arrivalTime,
                  summarizeContent: this.add.summarizeContent,
                  summaryContent: this.add.summaryContent,
                  id:this.add.id,
                  detailList:[]
                }
                this.add = data
              }
            }
            ss.MuBiao.saveOrUpdate(this.add).then(response => {
              if (response.f) {
                this.$message({
                  type: "success",
                  message: response.msg
                });
                //this.readd();
                this.query();
                //this.newDialog = false;
                this.showDialog = false;
                //this.updateDialog = false;
                this.closeDialogSummarize()
              } else {
                this.$message({
                  type: "error",
                  message: response.msg
                });
              }

            })
          },
            del(id){
                this.$confirm("确定要删除吗？", '提示')
                    .then(_ => {
                        ss.MuBiao.del({id:id}).then(response => {
                            this.query();
                            this.$message({
                                type: "success",
                                message: response.msg
                            });
                        })
                    })
                    .catch(_ => {
                    })
            },
            showDetail(id){
                this.summarize = '1'
                this.add.id = id
                this.showDialog = true;
                this.showloading = true;
                ss.MuBiao.selectById({id:id}).then(rd => {
                    this.add = rd.obj;
                    this.showloading = false;
                });
            },
            updateDetail(id){
                this.updateDialog = true;
                this.updateloading = true;
                ss.MuBiao.selectById({id:id}).then(rd => {
                    this.add = rd.obj;
                    this.add.weekPrice = rd.obj.weekPrice
                    this.$nextTick(() => {
                      for(let i=0;i< rd.obj.detailList.length;i++){
                        if(rd.obj.detailList[i].projectNameChild != null && rd.obj.detailList[i].projectNameChild != ''){
                          rd.obj.detailList[i].isChild = true;
                          ss.MuBiao.getProjectChild(rd.obj.detailList[i].projectName).then(res => {
                            this.ufrom[i].listProjectChild = [];
                            this.ufrom[i].listProjectChild = res.msg;
                            console.log(" this.ufrom[i].listProjectChild",i,this.ufrom[i].listProjectChild)
                          })
                        }
                      }
                      this.ufrom = rd.obj.detailList
                    });

                    this.updateloading = false;
                });
              //进行强制数据渲染
              this.$forceUpdate();
            },
            showSummarizes(id){
              this.showSummarize = true;
              this.showSummarizeing = true;
              ss.MuBiao.getClearPlanById({id:id}).then(rd => {
                this.add = rd.obj;
                this.add.weekPrice = rd.obj.weekPrice
                for(var i=0;i< rd.obj.detailList.length;i++){
                  if (rd.obj.detailList[i].summarizeContent == null || rd.obj.detailList[i].summarizeContent == ''){
                    rd.obj.detailList[i].summarizeContent = rd.obj.detailList[i].dayPlanContent
                  }
                  if(rd.obj.detailList[i].projectNameChild != null && rd.obj.detailList[i].projectNameChild != ''){
                    rd.obj.detailList[i].isChild = true;
                  }
                }
                this.ufrom = rd.obj.detailList
                this.showSummarizeing = false;
              });

            },

            //判断编辑周目标时,项目信息是否可以删除
            getDeleteStatus(key){
                if(key == 1){
                    return true;
                }
            },
            getAllLianqun(){
                ss.createMonthGoal.getAllLianqun().then(rd => {
                    this.lianqunList = rd;
                })
            },
            getRowSpan() {
                this.rowSpanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index == 0) {
                        this.rowSpanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].userName== this.tableData[index - 1].userName && this.tableData[index].week== this.tableData[index - 1].week
                            && this.tableData[index].year== this.tableData[index - 1].year) {
                            this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
                            this.rowSpanArr.push(0);
                            this.tableData[index].userName= this.tableData[index - 1].userName;
                        } else {
                            this.rowSpanArr.push(1);
                            this.position = index;
                        }
                    }
                });

            },

            objectSpanMethod({ row,column, rowIndex,columnIndex }) {
                // 只合并区域位置
                if (columnIndex === 0) {
                    const _row = this.rowSpanArr[rowIndex];
                    return {
                        rowspan: _row, //行
                        colspan: 1 //列
                    };
                }
                if(columnIndex === 1){
                    const _row = this.rowSpanArr[rowIndex];
                    const _col = _row>0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
                //分条显示数据
                if(columnIndex === 2 || columnIndex === 4 ||columnIndex === 3
                    || columnIndex === 15 || columnIndex === 16 ||columnIndex === 17 || columnIndex === 13 || columnIndex === 14
                    || columnIndex === 12 || columnIndex === 11 || columnIndex === 10
                ){
                    const _row = this.rowSpanArr[rowIndex];
                    const _col = _row>0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },

            query(){
                ss.MuBiao.page(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    this.getRowSpan();
                });
                console.log("1111111")
            },
            create(){
                this.add = {
                    year :new Date().getFullYear(),
                    type : 2,
                    month :new Date().getMonth()+2
                },
                    this.newDialog = true;
            },
//取消按钮
            exit() {
                this.newDialog = false;
                this.showDialog = false;
                this.updateDialog = false;
                this.showSummarize = false;
            },
            handleFilter() {
              this.query();
            },
            checkRank() {
                this.$router.push("/paiming");
            },

            typeIndex(index){
                return index+(this.q2.pageNo-1)*this.q2.pageSize+1;
            },

          //明细导出
          exportExcel() {
            // updownfile.down("/api/swyl/v1/mubiao/userDailyTarget/downloadExcelTy",this.q,"post",'data');
            ss.MuBiao.downloadBatchExcelMubiaoWeek(this.q).then(res => { // 处理返回的文件流
              const link = document.createElement('a')
              let blob = new Blob([res],{type: 'application/vnd.ms-excel'});
              link.style.display = 'none'
              link.href = URL.createObjectURL(blob);
              link.setAttribute('download', `用户交互-周目标管理导出详情.xlsx`)
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            }).catch(function (error) {
              console.log("导出错误",error.toString())
            });
          },
            //重置
            rest() {
                var pageSize=this.q.pageSize;
                var pageNo=this.q.pageNo;
                var total=this.q.total;
                var lqType=this.q.lqType;
                var year=this.q.year;
                this.q= {
                    pageSize: pageSize,
                    pageNo: pageNo,
                    total:total,
                    type: 2,
                    lqType: lqType,
                    year:year,
                }
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            //新增经销商
            //新增
            adduser() {
                this.f.userName = '';
                this.f.areaCode = '';
                this.f.channelCode = '';
                this.f.department = '';
                this.f.contactuserName = '';
                this.f.telephone = '';
                this.saveorupdate = 1;
                this.dialogFormVisible = true;
            },
            //弹框关闭
            cancel(formName) {
                this.dialogFormVisible = false;
                this.f.userName = '';
                this.f.areaCode = '';
                this.f.channelCode = '';
                this.f.department = '';
                this.f.contactuserName = '';
                this.f.telephone = '';
                this.f.userType = '';
                this.$refs[formName].resetFields();
            },
            insert() {
                var subflag = false;
                //必填项校验
                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    //潜在经销商
                    if(this.f.userType == '1'){
                        ss.customer.insertAgent(this.f).then(rd => {
                            this.query();
                            this.$msg.msgs(rd.msg);
                            this.dialogFormVisible = false;
                        })
                    }else if(this.f.userType == '2'){
                        //潜在客户
                        ss.customer.insert(this.f).then(rd => {
                            this.query();
                            this.$msg.msgs(rd.msg);
                            this.dialogFormVisible = false;
                        })
                    }
                }
            },
            getProjectChild(val,index){
              console.log(val,index,"getProjectChildgetProjectChildgetProjectChild")
              if(val == '' || val == null){
                  this.ufrom[index].projectNameChild = ''
              }else if(val == '增量布局' || val == '存量拓展' || val == '基础工作'){
                this.ufrom[index].projectNameChild = ''
                this.ufrom[index].isChild = true;
                ss.MuBiao.getProjectChild(val).then(res => {
                  console.log(res)
                  this.ufrom[index].listProjectChild = res.msg
                })
              }else {
                this.ufrom[index].isChild = false;
                this.ufrom[index].projectNameChild = ''
              }
            },
        },
        mounted() {
          this.query();
        }
    };
</script>

<style>
</style>
<style>
    .chosedialog .body_dilog{
        padding-top: 0px!important;
    }
    .chosedialog .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .chosedialog .el-dialog__body{
        padding: 0px 20px!important;
    }
    .chosedialog .h-pagination{
        padding-top:0px !important;
        padding-bottom:0px !important;
    }
    .ljjcaozuo .el-button [class*=el-icon-]+span{
        margin-left: 0;
    }
    .ljjcaozuo .h-el-icon{
        margin-right: 0;
    }
    .smTableRq .el-table tbody td .cell {
        padding-top: 0.03rem;
        padding-bottom: 0.03rem;
    }
    .smTableRq .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .smTableRq .el-input__inner{
        background: transparent;
    }
    .ljjtablepaddingsrq .h-tableInput{
        margin-top: 0.05rem;
    }
    .ljjtablepaddingsrq .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
        color: #616467;
        font-size: 0.16rem;
    }
    .ljjtablepaddingsrq .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }

    .X-dai .h-formbLine .h-elformWrap-2 {
        padding-right: 0.1rem;
        width: 50%;
    }
    .X-dai .h-formbLine .h-elformWrap-3 {
        padding-right: 0.1rem;
        width: 47% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-4 {
        padding-right: 0.2rem;
        width: 48%;
    }
    .X-dai .h-formbLine .h-elformWrap-1 {
        padding-right: 0;
        width: 100% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-1 .el-form-item__label{
        width: 22%;
    }
    .X-dai .h-formbLine .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }
    .X-dai .h-formbLine .h-elformWrap-4 .el-form-item__content{
        width: 65%;
    }
    .X-dai .h-formbLine .h-elformWrap-3 .el-form-item__label{
        width: 16%;
    }
    .X-dai .h-formbLine .h-elformWrap-3 .el-form-item__content{
        width: 82%;
    }
    .X-dai .h-formbLine .danwei .el-input{
        width:70%
    }
    .X-dai .h-formbLine .el-form-item__label {
        width:auto;
    }
    .projectCon{

    }
    .projectCon p{
        display: flex;
        justify-content: space-between;
        align-items:center;
        font-size: 14px;
        border-bottom:#1b78e6 1px dashed;
        padding: 5px 0;
        margin: 0 auto 10px auto;
        color: #1b78e6;
    }
    .projectCon .el-form-item__content{
        width: 70% !important
    }
    .X-dai .h-formbLine .el-form-item__content {
        width: 49%;
    }
</style>
